document.addEventListener("DOMContentLoaded", function(event) {
  const sectionID = 
  new Swiper('.design-and-concept-image-wrapper', {
    // Optional parameters
    slidesPerView: 1.1,
    spaceBetween: 12,
    direction: 'horizontal',
    scrollbar: {
      el: '.design-and-concept-image-wrapper .swiper-scrollbar',
      draggable: true
    },
    navigation: {
      nextEl: '.design-and-concept-image-wrapper .swiper-button-next',
      prevEl: '.design-and-concept-image-wrapper .swiper-button-prev'
    }
  });
})